import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Statistics } from '@/models/leaderboard';
import { GETTERS as LEADERBOARD_GETTERS } from '@/store/leaderboard';

@Component({
    name: 'CmgSoeRankDescriptionModal'
})

export default class CmgSoeRankDescriptionModal extends Vue {

    get visible(): boolean {
        return this.$appStore.state.ui.modals.soeRankDescriptionModal.visible;
    }

    get rankType(): 'local' | 'state' | 'national' {
        return this.$appStore.state.ui.modals.soeRankDescriptionModal.args?.type || 'local';
    }

    get isMobile(): boolean {
        return this.$services.ui.isMobile();
    }

    get orderCount(): number {
        return this.$appStore.getters[LEADERBOARD_GETTERS.ORDER_COUNT];
    }

    get isInZeroState(): boolean {
        return this.orderCount === 0 || this.statistics.nationalRankPercentage === 0;
    }

    get statistics(): Statistics {
        return this.$appStore.state.leaderboard.statistics;
    }

    get nationalRankPercentage(): number {
        return this.statistics.nationalRankPercentage;
    }

    async mounted() {
        this.$services.ui.firstFocus();
    }

    get localDescription(): string {
        return `Your rank is based on the total number of orders placed.<br><br>See how you stack up at your go-to restaurant. If you visit multiple locations the same amount of times, your most recent visit breaks the tie.`;
    }

    get stateDescription(): string {
        return `Your rank is based on the total number of orders placed.<br><br>Check your rank across your state. If you order in multiple states, we use the one you visit most. If that's tied, your most recent visit decides.`;
    }

    get nationalDescription(): string {
        return `Your rank is based on the total number of orders placed.<br><br>This is the big stage. Everyone's ranked together based on total qualifying orders.`;
    }

    get rankImage(): string {
        if (this.rankType === 'local') {
            return this.$appStore.state.cms.images.loyalty.leaderboardRankDescriptionLocalRank.default;
        } else if (this.rankType === 'state') {
            return this.$appStore.state.cms.images.loyalty.leaderboardRankDescriptionStateRank.default;
        } else {
            return this.$appStore.state.cms.images.loyalty.leaderboardRankDescriptionNationalRank.default;
        }
    }

    get stateRankImage(): string {
        return !this.isInZeroState ? this.statistics.stateImageUri : this.$appStore.state.cms.images.icons.pepperSmall.default;
    }
    onClose() {
        this.$services.ui.setModalVisibility('soeRankDescriptionModal', false);
    }

}
